function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useId } from '@applyboard/crystal-ui';
import { useEffect, useMemo, useRef, useState } from 'react';
import { appendInlineHtml, htmlSubstr } from "../../utils/html";
import { flushSync } from 'react-dom';
import { assert } from "../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Renders some raw HTML.  Has the following features:
 * 1. Styles the HTML to be more consistent with `crystal-ui` styles
 * 2. Allows for truncation of the HTML with a "See more" button
 */
export function RawHtml(_ref) {
  var dangerouslySetInnerHTML = _ref.dangerouslySetInnerHTML,
    truncationSettings = _ref.truncationSettings,
    onToggleTruncation = _ref.onToggleTruncation;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useTruncatedHtml = useTruncatedHtml({
      rawHtml: dangerouslySetInnerHTML.__html,
      truncationSettings: truncationSettings,
      expanded: expanded
    }),
    html = _useTruncatedHtml.html,
    seeMoreClassName = _useTruncatedHtml.seeMoreClassName;
  var divRef = useRef(null);

  // eslint-disable-next-line no-restricted-syntax
  useEffect(function () {
    var container = divRef.current;
    if (!container) return;
    var handler = function handler(e) {
      if (e.target instanceof Element && e.target.tagName === 'BUTTON') {
        var _container$querySelec;
        onToggleTruncation === null || onToggleTruncation === void 0 ? void 0 : onToggleTruncation(!expanded);
        flushSync(function () {
          setExpanded(!expanded);
        });
        (_container$querySelec = container.querySelectorAll('button')[0]) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.focus();
      }
    };
    container.addEventListener('click', handler);
    return function () {
      container.removeEventListener('click', handler);
    };
  }, [expanded, onToggleTruncation]);
  return _jsx("div", {
    ref: divRef,
    dangerouslySetInnerHTML: {
      __html: html
    },
    css: function css(_ref2) {
      var colors = _ref2.colors,
        spacing = _ref2.spacing;
      return _defineProperty({
        // Style the HTML to be more consistent with `crystal-ui` styles.  This
        // duplicates some styling from `crystal-ui`.  Ideally we should use the
        // Markdown component to reuse `crystal-ui` components/styling
        //
        // Also note, some styles here are over-riding the infamously overly
        // aggressive legacy.min.css file.  For example, we need to reenable the
        // focus styles for links to prevent the a11y issue caused by
        // legacy.min.css disabling it
        fontFamily: '"Open Sans"',
        fontWeight: 400,
        color: colors.textSecondaryStark,
        lineHeight: '1.5rem',
        fontSize: '1rem',
        '& p': {
          fontWeight: 400,
          margin: 0
        },
        '& a': {
          color: colors.textPrimary,
          textDecoration: 'underline',
          wordBreak: 'break-all',
          '&:focus-visible': {
            outline: 'solid',
            outlineColor: colors.actionPrimary,
            outlineWidth: spacing['2px'],
            borderRadius: spacing[1]
          },
          '&:visited': {
            color: colors.textMagic
          }
        },
        '& ul, h1, h2': {
          margin: 0
        }
      }, "& .".concat(seeMoreClassName), {
        background: 'none',
        color: colors.actionPrimary,
        textDecoration: 'underline',
        border: 'none',
        padding: 0,
        backgroundColor: 'white',
        fontSize: 'inherit',
        cursor: 'pointer'
      });
    }
  });
}

/**
 * Truncates the HTML, adds a "See More" / "See Less" button, and returns the
 * result
 */
function useTruncatedHtml(_ref4) {
  var rawHtml = _ref4.rawHtml,
    truncationSettings = _ref4.truncationSettings,
    expanded = _ref4.expanded;
  var seeMoreClassName = "c".concat(useId());
  var _ref5 = truncationSettings || {},
    maxChars = _ref5.maxChars,
    _ref5$seeLessText = _ref5.seeLessText,
    seeLessText = _ref5$seeLessText === void 0 ? 'See less' : _ref5$seeLessText,
    _ref5$seeMoreText = _ref5.seeMoreText,
    seeMoreText = _ref5$seeMoreText === void 0 ? 'See more' : _ref5$seeMoreText,
    srOnlyText = _ref5.srOnlyText;

  // Prevent XSS attacks by ensuring the "see less" text only contains word characters
  useMemo(function () {
    assert(/^[\w\s]*$/.test(seeLessText), 'Button text contained invalid characters');
  }, [seeLessText]);

  // Prevent XSS attacks by ensuring the "see more" text only contains word characters
  useMemo(function () {
    assert(/^[\w\s]*$/.test(seeMoreText), 'Button text contained invalid characters');
  }, [seeMoreText]);

  // Prevent XSS attacks by encoding `linkTextSrOnly` using the browser's DOM
  // apis. This is expensive, so we use useMemo and we reserve this strategy for
  // content that is user-generated
  var sanitizedLinkTextSrOnly = useMemo(function () {
    return encodeHTML(srOnlyText);
  }, [srOnlyText]);
  var _htmlSubstr = htmlSubstr(rawHtml, maxChars),
    result = _htmlSubstr.result,
    truncated = _htmlSubstr.truncated;
  if (!truncated) {
    return {
      html: result,
      seeMoreClassName: seeMoreClassName
    };
  }
  var linkTextSrOnlyHtml = sanitizedLinkTextSrOnly ? "<span style=\"border: 0; clip: rect(0,0,0,0); height: 1px; margin: -1px; overflow: hidden; padding: 0; position: absolute; white-space: nowrap; width: 1px;\"> ".concat(sanitizedLinkTextSrOnly, "</span>") : '';
  if (expanded) {
    return {
      html: appendInlineHtml(rawHtml, "<span> <button class=\"".concat(seeMoreClassName, "\" type=\"button\">").concat(seeLessText).concat(linkTextSrOnlyHtml, "</button></span>")),
      seeMoreClassName: seeMoreClassName
    };
  }
  return {
    html: appendInlineHtml(result, "<span>".concat("\u2026", " <button class=\"", seeMoreClassName, "\" type=\"button\">").concat(seeMoreText).concat(linkTextSrOnlyHtml, "</button></span>")),
    seeMoreClassName: seeMoreClassName
  };
}
function encodeHTML(str) {
  if (typeof str !== 'string') {
    return str;
  }
  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML;
}